/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-04-24 10:29:47
 */
import React, { useRef } from 'react'
import { Layout, Tabs } from 'antd'
import Undo, { UndoRef } from './undo'
import Done, { DoneRef } from './done'

import PageHeader from '@/components/PageHeader'
import AntdProvider from '@/components/AntdProvider'
const Content = Layout.Content

export default function OrdersPage() {
  const doneRef = useRef<DoneRef>(null)
  const undoRef = useRef<UndoRef>(null)

  // antd Tabs 使用 items 模式
  const tabItems = [
    {
      key: '1',
      label: '未开票',
      children: <Undo ref={undoRef} />
    },
    {
      key: '2',
      label: '已开票',
      children: <Done ref={doneRef} />
    }
  ]

  return (
    <AntdProvider>
      <Layout className="Customer">
        <PageHeader
          className="Header"
          ghost={true}
          title="我的订单"
          subTitle="开票受理时间：工作日 10:00-20:30"
          // extra={<Button type="primary">合并开票</Button>}
        />
        <Content className="content" style={{ padding: 16 }}>
          <Tabs
            defaultActiveKey="1"
            tabBarStyle={{ margin: 0 }}
            items={tabItems}
            onChange={(activeKey) => {
              if (activeKey === '1') {
                undoRef.current && undoRef.current.refresh()
              } else {
                doneRef.current && doneRef.current.refresh()
              }
            }}
          />
        </Content>
      </Layout>
    </AntdProvider>
  )
}
